import { Model } from '@/models/Model';
export class Setting extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Setting';
        this.$endpoint = '/settings';
        this.$fillable = ['name'];
    }
    resolvePrimaryKey() {
        return '';
    }
}
